/* eslint-disable no-magic-numbers */
import { DateTime } from "luxon";

import {
	MemberGrowthOpportunitiesV3,
	ConfidenceLevel
} from "@teaming/common-enums";

export default ( { i18n, } ) => {
	return ( { timezone, teamId, opportunity, onboardingVersion = 3, } ) => {
		const MemberGrowthOpportunities = MemberGrowthOpportunitiesV3;

		if ( !MemberGrowthOpportunities.includes( opportunity ) ) {
			throw new Error( "not a valid member opportunity" );
		}

		const now = DateTime.now().setZone( timezone );
		const duration = opportunity === MemberGrowthOpportunities.WORK_VALUE ? 365 : 30;

		const titleKeys = {
			3: `common-gokr.domain.goalTitle${ opportunity }`,
		};
		const titleKey = titleKeys[ onboardingVersion ] || "";

		return {
			title: i18n.global.t( titleKey ),
			teamId,
			plannedStartDate: now.toISO(),
			plannedFinishDate: now.plus( { days: duration, } ).toISO(),
			confidence: ConfidenceLevel.HIGH,
			archived: false,
			keyResults: [],
		};
	};
};
